import React from 'react';
import { MessageContextItemContainerProps } from './contextItemProps';
import { MessageSolutionContextItemContainerProps } from './solution';

export function createMessageContextItemContainer(config: {
    Container: {
        Solution: React.FC<MessageSolutionContextItemContainerProps>;
        // Document: React.FC<MessageDocumentContextItemContainerProps>;
    };
}): React.FC<MessageContextItemContainerProps> {
    const {
        Container: {
            Solution: SolutionContainer,
            // Document: DocumentContainer
        },
    } = config;
    return ({ ...containerProps }) => {
        const {
            as: {
                Solution: SolutionView,
                // Document: DocumentView
            },
            ...rest
        } = containerProps;
        if (containerProps.item.context.kind === 'solution') {
            return (
                <SolutionContainer
                    {...containerProps}
                    as={SolutionView}
                    item={containerProps.item.context}
                />
            );
        }
        // if (containerProps.item.context.kind === 'reference') {
        //     return (
        //         <DocumentContainer
        //             {...containerProps}
        //             as={DocumentView}
        //             item={containerProps.item.context}
        //         />
        //     );
        // }
        console.error('not implemented', containerProps.item.context.kind);
        return <>not implemented</>;
    };
}
